import { Component, OnInit, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MessagesService} from '../shared/services/messages.service';
import {LoadingService} from '../shared/services/loading.service';
import {UrlBuilderService} from '../services/url-builder.service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Course} from '../models/course.model';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { NgStyle } from '@angular/common';
import { DigitalAssetsSvgSpriteComponent } from './digital-assets-svg-sprite.component';
import { DialogCloseIconSvgComponent } from '../svg-sprites/general/dialog-close-icon-svg.component';
import { DownloadIconSvgComponent } from '../svg-sprites/general/download-icon-svg.component';

@Component({
    selector: 'digital-assets-dialog',
    templateUrl: './digital-assets-dialog.component.html',
    styleUrls: ['./digital-assets-dialog.component.scss'],
    imports: [MatProgressSpinnerModule, NgStyle, FormsModule, MatTooltipModule, TranslateModule, DigitalAssetsSvgSpriteComponent, DialogCloseIconSvgComponent, DownloadIconSvgComponent]
})
export class DigitalAssetsDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<DigitalAssetsDialogComponent>>(MatDialogRef);
  private ub = inject(UrlBuilderService);
  private messages = inject(MessagesService);
  private router = inject(Router);
  private loading = inject(LoadingService);


  course: Course;
  data: any;

  // for images
  certximgurl: string;
  certdownloadimgurl: string;
  certificateimgurl: string;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.data = data;
  }

  ngOnInit() {

    // for images
    this.certximgurl = this.ub.buildImageUrl("images/digital-assets/cert-x-sign.svg");
    this.certdownloadimgurl = this.ub.buildImageUrl("images/digital-assets/cert-download-white.svg");
    this.certificateimgurl = this.ub.buildImageUrl("images/digital-assets/certificate-background-image-small.jpg");

    if (this.data.course) {
      this.course = this.data.course;
    }
  }

  close() {
    this.dialogRef.close();
  }
  
  getCertificate() {
    // Close the dialog with 'getCertificate' result
    this.dialogRef.close('getCertificate');
    
    // Navigate to certificate page if URL is available
    if (this.data.course && this.data.course.url) {
      this.router.navigate(['/certificates', this.data.course.url]);
    }
  }

  convertStringToInt(str) {
    var Num = parseInt(str);
    return Num;
  }

  FloatToRoundNum(float) {
    var avg = Number((float).toFixed());
    return avg;
  }
}
